import React, { useState, useContext } from "react";
import { Box, Input, Text, useToast } from "@chakra-ui/react";
import { ProductsContext } from "../../Context/ProductsContext";
import FormModal from "../../Common/FormModal";

const AddCategory = ({ isOpen, setIsOpen }) => {
  const [newCategory, setNewCategory] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [newCategoryValidation, setNewCategoryValidation] = useState();
  const { addCategory } = useContext(ProductsContext);
  const toast = useToast();

  const handleSubmitCategory = async () => {
    setIsSubmitting(true);
    if (newCategory.length === 0) {
      setNewCategoryValidation("Ingrese un nombre");
      setIsSubmitting(false);
      return false;
    }
    setNewCategoryValidation("");
    try {
      await addCategory(newCategory);
      setNewCategory("");
      setIsOpen(false);
      toast({
        title: "Categoria agregada con éxito.",
        status: "success",
        duration: 4000,
        isClosable: true,
      });
    } catch (e) {
      toast({
        title: "Se ha producido un error.",
        description: e,
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
    setIsSubmitting(false);
  };

  return (
    <FormModal
      title={"Agregar nueva categoria"}
      action={() => handleSubmitCategory(newCategory)}
      isModalOpen={isOpen}
      setIsModalOpen={setIsOpen}
      isSubmitting={isSubmitting}
    >
      <Box w="100%" mr="1">
        <Input
          placeholder={"Ingrese una nueva categoria"}
          value={newCategory}
          isInvalid={newCategoryValidation}
          errorBorderColor="red.300"
          onChange={(e) => setNewCategory(e.target.value)}
        ></Input>
        {newCategoryValidation ? (
          <Text color="red.300">{newCategoryValidation}</Text>
        ) : null}
      </Box>
    </FormModal>
  );
};

export default AddCategory;
